export default __webpack_public_path__ + "static/media/srectr-instrument.7552510e.jpeg";